export default {"src":"/_next/static/media/star_active.6515d166.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};